import React, { useState } from "react";
import DomainSeoHelmet from "../agentic/DomainSeoHelmet";
import DomainHiddenSeoContent from "../agentic/DomainHiddenSeoContent";
import DomainUseCaseCard, { DOMAIN_PAGE_STYLES } from "../agentic/domainUseCaseLayout";
import UseCaseIndexGrid from "../agentic/UseCaseIndexGrid";
import RpaProcessFlow from "./RpaProcessFlow";
import {
  ENERGY_DOMAIN_INTRO,
  ENERGY_GROUPS,
  ENERGY_USE_CASES_SEO,
  ENERGY_DOMAIN_FAQS,
  ENERGY_ITEM_LIST_JSONLD,
  ENERGY_BREADCRUMB_JSONLD,
  ENERGY_WEBPAGE_JSONLD,
  ENERGY_FAQ_JSONLD,
} from "../../data/rpa/energy-utilities-domainUseCases";

function UseCaseCard({ useCase }) {
  return (
    <DomainUseCaseCard
      useCase={useCase}
      flow={<RpaProcessFlow useCase={useCase} />}
    />
  );
}

function GroupSection({ group }) {
  const cases = ENERGY_USE_CASES_SEO.filter((uc) => uc.groupId === group.id);
  if (!cases.length) return null;
  return (
    <section id={group.id} className="fin-section" aria-labelledby={`${group.id}-heading`}>
      <h2 id={`${group.id}-heading`}>{group.label}</h2>
      <div className="fin-list">
        {cases.map((uc) => (
          <UseCaseCard key={uc.id} useCase={uc} />
        ))}
      </div>
    </section>
  );
}

export default function EnergyRpaDomainContent() {
  const [activeFilter, setActiveFilter] = useState("all");
  const visibleGroups =
    activeFilter === "all"
      ? ENERGY_GROUPS
      : ENERGY_GROUPS.filter((group) => group.id === activeFilter);

  return (
    <div className="fin-page">
      <DomainSeoHelmet
        intro={ENERGY_DOMAIN_INTRO}
        domainSlug="energy-utilities-domain"
        basePath="/rpa-use-cases"
        useCaseCount={ENERGY_USE_CASES_SEO.length}
        groupCount={ENERGY_GROUPS.length}
        itemListJsonLd={ENERGY_ITEM_LIST_JSONLD}
        faqJsonLd={ENERGY_FAQ_JSONLD}
        breadcrumbJsonLd={ENERGY_BREADCRUMB_JSONLD}
        webPageJsonLd={ENERGY_WEBPAGE_JSONLD}
        keywords="Energy & Utilities automation, document AI + RPA, workflow automation, robotic process automation India UAE KSA UK USA"
        sectionLabel=""
      />
      <style>{DOMAIN_PAGE_STYLES}</style>
      <header className="fin-hero">
        <div className="fin-hero-inner">
          <h1>{ENERGY_DOMAIN_INTRO.title}</h1>
          {ENERGY_DOMAIN_INTRO.content ? <p>{ENERGY_DOMAIN_INTRO.content}</p> : null}
        </div>
      </header>
      <UseCaseIndexGrid
        useCases={ENERGY_USE_CASES_SEO}
        groups={ENERGY_GROUPS}
        heading="Energy & Utilities Use Cases"
        onFilterChange={setActiveFilter}
      />
      <div className="fin-wrap">
        {visibleGroups.map((group) => (
          <GroupSection key={group.id} group={group} />
        ))}
      </div>
      <DomainHiddenSeoContent
        domainTitle={ENERGY_DOMAIN_INTRO.title}
        domainFaqs={ENERGY_DOMAIN_FAQS}
        useCases={ENERGY_USE_CASES_SEO}
      />
    </div>
  );
}

